var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useMemo } from 'react';
import { useDeleteMany, } from "../../dataProvider/useDeleteMany.js";
import { useRefresh } from "../../dataProvider/useRefresh.js";
import { useListContext } from "../list/useListContext.js";
import { useNotify } from "../../notification/useNotify.js";
import { useResourceContext } from "../../core/useResourceContext.js";
import { useTranslate } from "../../i18n/useTranslate.js";
export var useBulkDeleteController = function (props) {
    var _a = props.mutationMode, mutationMode = _a === void 0 ? 'undoable' : _a, _b = props.mutationOptions, mutationOptions = _b === void 0 ? {} : _b, successMessage = props.successMessage;
    var mutationMeta = mutationOptions.meta, otherMutationOptions = __rest(mutationOptions, ["meta"]);
    var resource = useResourceContext(props);
    var notify = useNotify();
    var refresh = useRefresh();
    var translate = useTranslate();
    var _c = useListContext(), selectedIds = _c.selectedIds, onUnselectItems = _c.onUnselectItems;
    var _d = useDeleteMany(resource, undefined, {
        onSuccess: function () {
            notify(successMessage !== null && successMessage !== void 0 ? successMessage : "resources.".concat(resource, ".notifications.deleted"), {
                type: 'info',
                messageArgs: {
                    smart_count: selectedIds.length,
                    _: translate('ra.notification.deleted', {
                        smart_count: selectedIds.length,
                    }),
                },
                undoable: mutationMode === 'undoable',
            });
            onUnselectItems(true);
        },
        onError: function (error) {
            notify(typeof error === 'string'
                ? error
                : (error === null || error === void 0 ? void 0 : error.message) || 'ra.notification.http_error', {
                type: 'error',
                messageArgs: {
                    _: typeof error === 'string'
                        ? error
                        : error === null || error === void 0 ? void 0 : error.message,
                },
            });
            refresh();
        },
    }), deleteMany = _d[0], isPending = _d[1].isPending;
    var handleDelete = useCallback(function () {
        deleteMany(resource, {
            ids: selectedIds,
            meta: mutationMeta,
        }, __assign({ mutationMode: mutationMode }, otherMutationOptions));
    }, [
        deleteMany,
        mutationMeta,
        mutationMode,
        otherMutationOptions,
        resource,
        selectedIds,
    ]);
    return useMemo(function () { return ({
        isPending: isPending,
        isLoading: isPending,
        handleDelete: handleDelete,
    }); }, [isPending, handleDelete]);
};
//# sourceMappingURL=useBulkDeleteController.js.map